/**
 * Visual dual-handle price slider. Stays out of Dawn's own <price-range>
 * indexing (facets.js) by writing into the real "From"/"To" text inputs
 * instead of replacing them, then firing 'input' so the existing
 * <facet-filters-form> (bound at the form level) picks it up exactly like a
 * typed value would.
 *
 * Looks up those two inputs the same way Dawn's own PriceRange class does —
 * scoped to the enclosing <price-range> via querySelector, not
 * document.getElementById — because facets.liquid renders this filter
 * twice per page (vertical + horizontal layout) reusing the same
 * id_prefix, so the "From"/"To" ids are duplicated across the page and
 * getElementById would silently grab the wrong instance's inputs.
 */
(function () {
  function initSlider(root) {
    var priceRange = root.closest('price-range');
    if (!priceRange) return;
    var textInputs = priceRange.querySelectorAll('input[type="text"]');
    var minInput = textInputs[0];
    var maxInput = textInputs[1];
    var minThumb = root.querySelector('[data-price-slider-min-thumb]');
    var maxThumb = root.querySelector('[data-price-slider-max-thumb]');
    var range = root.querySelector('[data-price-slider-range]');
    var minLabel = root.querySelector('[data-price-slider-min-label]');
    var maxLabel = root.querySelector('[data-price-slider-max-label]');
    if (!minInput || !maxInput || !minThumb || !maxThumb || !range) return;

    var bounds = parseInt(root.getAttribute('data-max'), 10) || 10000;

    function formatNumber(value) {
      return Number(value).toLocaleString('en-IN');
    }

    function paint() {
      var minVal = Number(minThumb.value);
      var maxVal = Number(maxThumb.value);
      var minPercent = (minVal / bounds) * 100;
      var maxPercent = (maxVal / bounds) * 100;
      range.style.left = minPercent + '%';
      range.style.right = 100 - maxPercent + '%';
      if (minLabel) minLabel.textContent = formatNumber(minVal);
      if (maxLabel) maxLabel.textContent = formatNumber(maxVal);
    }

    function syncFromThumbs(commit) {
      var minVal = Number(minThumb.value);
      var maxVal = Number(maxThumb.value);

      if (minVal > maxVal) {
        if (document.activeElement === minThumb) {
          maxVal = minVal;
          maxThumb.value = maxVal;
        } else {
          minVal = maxVal;
          minThumb.value = minVal;
        }
      }

      paint();

      if (!commit) return;
      minInput.value = minVal;
      maxInput.value = maxVal;
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Keep the slider in sync if someone types an exact value instead.
    minInput.addEventListener('change', function () {
      if (minInput.value !== '') minThumb.value = minInput.value;
      paint();
    });
    maxInput.addEventListener('change', function () {
      if (maxInput.value !== '') maxThumb.value = maxInput.value;
      paint();
    });

    minThumb.addEventListener('input', function () {
      syncFromThumbs(false);
    });
    maxThumb.addEventListener('input', function () {
      syncFromThumbs(false);
    });
    minThumb.addEventListener('change', function () {
      syncFromThumbs(true);
    });
    maxThumb.addEventListener('change', function () {
      syncFromThumbs(true);
    });

    paint();
  }

  function init() {
    document.querySelectorAll('price-range-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
